// extracted by mini-css-extract-plugin
export default {"root":"PageBuilderButtonItem-module-root-2fX"};